import {
  DEFAULT_START_DATE,
  DEFAULT_END_DATE,
} from '../components/widgets/AntLayout';

const API_BASE_URL =
  process.env.REACT_APP_NEWSARCHIVE_API_URL ||
  'https://api.newsarchive.alicetomassini.com';

const API_KEY = process.env.REACT_APP_NEWSARCHIVE_API_KEY || '';

// Headers to send on every JSON API request.
const apiHeaders = (extra = {}) =>
  API_KEY ? { ...extra, 'X-API-Key': API_KEY } : extra;

/**
 * Fetch articles by date with pagination support
 */
export const fetchArticlesByDate = async (date, pageNumber = 1) => {
  try {
    const params = new URLSearchParams({ date, page: pageNumber });
    const response = await fetch(`${API_BASE_URL}/articles?${params}`, {
      headers: apiHeaders(),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    return data.rows;
  } catch (error) {
    console.error('Failed to fetch articles:', error);
    return [];
  }
};

/**
 * Search articles with different search strategies
 */
export const searchArticles = async (
  searchTerm,
  searchType = 'broad',
  threshold = null,
) => {
  if (!searchTerm) {
    console.error('Search term is required');
    return [];
  }

  const savedRange = localStorage.getItem('searchDateRange');
  const [startDate, endDate] = savedRange
    ? JSON.parse(savedRange)
    : [DEFAULT_START_DATE, DEFAULT_END_DATE];

  const body = { searchTerm, searchType, startDate, endDate };
  // Only the semantic search type uses a distance threshold.
  if (searchType === 'semantic' && threshold != null) {
    body.threshold = threshold;
  }

  try {
    const response = await fetch(`${API_BASE_URL}/search`, {
      method: 'POST',
      headers: apiHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    return data.rows;
  } catch (error) {
    console.error('Search failed:', error);
    return [];
  }
};

/**
 * Fetch a specific article by ID
 */
export const getArticleById = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/articles/${encodeURIComponent(id)}`, {
      headers: apiHeaders(),
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const data = await response.json();
    return data.rows;
  } catch (error) {
    console.error('Failed to fetch article:', error);
    return [];
  }
};

/**
 * Get the image proxy URL for an article
 */
export const getImageUrl = (imageId) => {
  // /image is a public proxy (no API key) — it serves already-public images and
  // is loaded directly in <img src>, which can't send auth headers.
  return `${API_BASE_URL}/image?imageId=${encodeURIComponent(imageId)}`;
};
